'use strict';

const $ = jQuery.noConflict();

$(function() {
	const accordionBlock = {

		init: function() {
			this.accordion();
			this.fillPlaceholders();

			$(window).on('resize', this.fillPlaceholders.bind(this));
		},

		accordion: function() {
			$('[data-accordion-trigger]').on('click', function() {
				const $item = $(this).closest('[data-accordion-item]');
				const $body = $item.find('[data-accordion-body]');
				const $toggle = $item.find('.accordion-block__toggle');
				const isOpen = $item.hasClass('accordion-block__item--open');

				if (isOpen) {
					$item.removeClass('accordion-block__item--open');
					$toggle.attr('aria-expanded', 'false');
					$body.slideUp(280);
				} else {
					$('[data-accordion-item]').each(function() {
						const $otherItem = $(this);

						if ($otherItem[0] !== $item[0] && $otherItem.hasClass('accordion-block__item--open')) {
							$otherItem.removeClass('accordion-block__item--open');
							$otherItem.find('.accordion-block__toggle').attr('aria-expanded', 'false');
							$otherItem.find('[data-accordion-body]').slideUp(280);
						}
					});

					$item.addClass('accordion-block__item--open');
					$toggle.attr('aria-expanded', 'true');
					$body.slideDown(300);
				}
			});

			$(document).on('click', '.accordion-block__card--unavailable .accordion-block__card-btn', function(e) {
				e.preventDefault();
				e.stopPropagation();
			});
		},

		getColumnsCount: function() {
			const width = $(window).width();

			if (width <= 767) {
				return 1;
			} else if (width <= 1199) {
				return 2;
			}

			return 3;
		},

		placeholderHtml: function() {
			return `<div class="accordion-block__card accordion-block__card--placeholder">
				<span></span>
			</div>`;
		},

		fillPlaceholders: function() {
			const columns = accordionBlock.getColumnsCount();

			$('.accordion-block__grid').each(function() {
				const $grid = $(this);

				$grid.find('.accordion-block__card--placeholder').remove();

				const cardCount = $grid.find('.accordion-block__card').length;
				const remainder = cardCount % columns;

				if (remainder !== 0) {
					const needed = columns - remainder;

					for (let i = 0; i < needed; i++) {
						$grid.append(accordionBlock.placeholderHtml());
					}
				}
			});
		}
	};

	accordionBlock.init();
});
